"use client";

import { ResponsiveDialog } from "@repo/ui/components/responsive-dialog";
import { useTranslations } from "next-intl";
import ClassicLoader from "@/components/common/classic-loader";
import { Button } from "@/components/ui/button";

export const ClearCartDialog = ({
  isPending,
  onConfirm,
  onOpenChange,
  open,
}: {
  isPending: boolean;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
}) => {
  const t = useTranslations();

  return (
    <ResponsiveDialog
      closeLabel={t("common.cancel")}
      dialogClassName="gap-0 overflow-hidden p-0 md:w-[calc(100%-2rem)] md:max-w-110"
      footer={
        <div className="flex w-full items-center justify-between gap-4">
          <Button
            disabled={isPending}
            onClick={() => onOpenChange(false)}
            type="button"
            variant="outline"
          >
            {t("common.cancel")}
          </Button>
          <Button
            className="bg-brand-red-foreground text-white hover:bg-brand-red-foreground/90"
            disabled={isPending}
            onClick={onConfirm}
            type="button"
          >
            {t("cart.remove")}
            {isPending && <ClassicLoader className="ml-2 size-4" />}
          </Button>
        </div>
      }
      footerClassName="border-t px-6 py-4"
      headerClassName="border-b px-6 py-5"
      onOpenChange={onOpenChange}
      open={open}
      title={t("cart.clear")}
      titleClassName="font-medium text-2xl"
    >
      <p className="p-6 text-base text-brand-green1-300">
        {t("cart.clearConfirm")}
      </p>
    </ResponsiveDialog>
  );
};
